import { render, staticRenderFns } from "./SetPasswordView.vue?vue&type=template&id=2f57f958&"
import script from "./SetPasswordView.vue?vue&type=script&lang=js&"
export * from "./SetPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./SetPasswordView.vue?vue&type=style&index=0&id=2f57f958&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports